import { Component, effect, input, output, ChangeDetectionStrategy } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { MatIconModule } from '@angular/material/icon'
import { interval } from 'rxjs'

@Component({
  selector: 'lib-activity-progress',
  imports: [MatIconModule],
  templateUrl: './activity-progress.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './activity-progress.component.scss',
})
export class ActivityProgressComponent {
  readonly counter = toSignal(interval(1000), { initialValue: 0 })

  readonly finished = output()
  readonly items = input.required<string[]>()
  _ = effect(() => {
    if (this.counter() >= this.items().length) {
      this.finished.emit()
    }
  })
}
